import SeelLogo from '~/assets/seel.png';
import {
  DollarIcon,
  ReturnsIcon,
  TruckIcon,
} from '~/components/Icons/ItemIcons';
import Image from '~/components/Image';
import EstimatedDeliveryRow from '~/components/ItemDetails/EstimatedDeliveryRow';
import HelpLink from '~/components/Links/HelpLink';
import ZipPayLinkAndIcon from '~/components/ZipPay/ZipPayLinkAndIcon';
import ShieldIcon from '~/public/static/svg/ShieldIcon';
import { RailsItem } from '~/typings/services/rails/item';

export default function ItemValueProps({ item }: { item: RailsItem }) {
  return (
    <ul className="bg-grey-50 w-full space-y-2 rounded px-4 py-3 text-sm">
      <li className="flex items-center gap-2">
        <ShieldIcon className="h-6 w-6" />
        <span>
          Purchases protected by{' '}
          <HelpLink link="buyerProtection" className="underline">
            Buyer Guarantee
          </HelpLink>
        </span>
      </li>

      <li className="flex items-center gap-2">
        <ReturnsIcon className="h-6 w-6" />
        <span>
          Worry-Free Returns with{' '}
          <Image
            src={SeelLogo}
            className="mb-1 inline-block h-4 w-12"
            height={16}
            width={48}
            alt="Seel, our returns partner"
          />
        </span>
      </li>

      {item.estimated_delivery && (
        <li className="flex items-center gap-2">
          <TruckIcon className="h-6 w-6" />
          <EstimatedDeliveryRow item={item} />
        </li>
      )}

      <li className="flex items-center gap-2">
        <DollarIcon className="h-6 w-6" />
        <span className="flex flex-wrap items-center gap-1">
          <span>Buy now, pay later with</span>
          <ZipPayLinkAndIcon />
        </span>
      </li>
    </ul>
  );
}
